import CreateCourse from '../../components/create-course';

export default function CreateCoursePage() {
  return <CreateCourse />;
}
